import React from 'react'
import Sebrae from '../assets/imgs/sebrae.png'

const BcxSectionD = () => {
  return (
    <section id="sectionD">
      <div className="container">
        <div className="header">
          <div className="titulo">
            <img src={Sebrae} alt="Logo da Sebrae" />
            <h2>
              Uma Parceria com <br />
              <strong>soluções para sua empresa</strong>
            </h2>
          </div>
          <div className="descricao">
            <p>
              O Sebrae está oferecendo 2 capacitações online GRATUITAS e 1
              consultoria online GRATUITA aos empreendedores interessados.
            </p>
            <p>
              Mesmo sem a efetivação do crédito, você pode ter acesso a
              ferramentas que te ajudam a gerenciar melhor seus negócios.
            </p>
            <p>
              <strong>Aproveite essa oportunidade!</strong>
            </p>
          </div>
        </div>

        <div className="content">
          <div className="col">
            <h3>
              Capacitação GRATUITA
              <br />
              em Marketing e Vendas
            </h3>
            <a
              className="btn"
              href="https://digital.sebraers.com.br/produtos/marketing-e-vendas/curso/marketing-digital-direto-ao-ponto/"
              target="_blank"
              rel="noopener noreferrer"
            >
              acesse aqui
            </a>

            <h3>
              Capacitação GRATUITA
              <br />
              em Finanças
            </h3>
            <a
              className="btn"
              href=" https://digital.sebraers.com.br/produtos/financas/curso/curso-online-credisapi/"
              target="_blank"
              rel="noopener noreferrer"
            >
              acesse aqui
            </a>

            <h3>
              Orientação GRATUITA
              <br />
              sobre Crédito e Finanças
            </h3>
            <a
              className="btn"
              href="https://sebraers.com.br/destaque/consultoria-em-gestao/"
              target="_blank"
              rel="noopener noreferrer"
            >
              acesse aqui
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BcxSectionD
